/**
 * DetailTabbed — the body of one employee tab (demo /manage-team member detail, /profile tabs). The tab strip itself
 * belongs to the DetailPage template; the active tab lives in the URL (`?tab=`).
 */
import React from 'react';
import { EmployeeAssistant } from './EmployeeAssistant.js';
import { CurrentWorkPanel } from './panels/CurrentWorkPanel.js';
import { OutputsPanel } from './panels/OutputsPanel.js';
import { DecisionsPanel } from './panels/DecisionsPanel.js';
import { PerformancePanel } from './panels/PerformancePanel.js';
import { PermissionsPanel } from './panels/PermissionsPanel.js';
import { SupervisionPanel } from './panels/SupervisionPanel.js';
import type { DecisionRow } from './panels/DecisionsPanel.js';
import type { OutputRow } from './panels/OutputsPanel.js';
import type { EmployeeView } from '../shared';
import type { EmployeeTab } from './employee-tabs.js';

interface DetailTabbedProps {
  tab: EmployeeTab;
  employee: EmployeeView;
  grants?: Array<Record<string, unknown>>;
  linkedToProject: boolean;
  outputs?: OutputRow[];
  outputsHref?: string | null;
  decisions?: DecisionRow[];
  onOpenConversation?: () => void;
}

export const DetailTabbed: React.FC<DetailTabbedProps> = ({
  tab,
  employee,
  grants,
  linkedToProject,
  outputs = [],
  outputsHref,
  decisions = [],
  onOpenConversation,
}) => {
  switch (tab) {
    case 'work':
      return (
        <>
          <EmployeeAssistant
            employee={employee}
            onAction={onOpenConversation ? () => onOpenConversation() : undefined}
          />
          <CurrentWorkPanel
            employee={employee}
            linkedToProject={linkedToProject}
            onOpenConversation={onOpenConversation}
          />
        </>
      );
    case 'outputs':
      return <OutputsPanel outputs={outputs} openAllHref={outputsHref} />;
    case 'decisions':
      return <DecisionsPanel decisions={decisions} onOpenConversation={onOpenConversation} />;
    case 'perf':
      return <PerformancePanel employee={employee} />;
    case 'perms':
      return <PermissionsPanel grants={grants} />;
    case 'convo':
      return <SupervisionPanel employee={employee} onOpenThread={onOpenConversation} />;
  }
};
